import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/services/api/authentication/authentication.service';
import { UserSessionStore } from 'src/app/shared/services/user-session.store';

@Component({
  selector: 'app-sso',
  imports: [],
  templateUrl: './sso.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sso.component.scss',
})
export class SsoComponent {
  slug: string = '';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private sessionStore: UserSessionStore,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (this.sessionStore.isAuthenticated()) {
        this.router.navigate(['/']);
        return;
      }
      const slug = params['slug'];
      const fromUrl = this.route.snapshot.queryParams['fromUrl'];
      this.authService.discover({ slug, redirect_url: fromUrl }).then(result => {
        if (result?.sso && result.authorization_url) {
          window.location.href = result.authorization_url;
        } else {
          this.router.navigate(['/login'], { queryParams: { fromUrl } });
        }
      });
    });
  }
}
